import {Consultation} from './consultation';

export class Repos {
	repos_id : number;
	repos_date:Date;
	repos_date_retour:any;
	repos_nombre_jours:any;
	repos_motif:any;
	id_consultation : number;
	consultation:Consultation;

	constructor(){
			
	}

}
